// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getAllFromController, getPersonInteractions, getLoggedInUser } from "@lib/api"

// export const getAllData = createAsyncThunk("appUsers/getAllData", async () => {
//   const response = await axios.get("/api/users/list/all-data")
//   return response.data
// })
// export const getData = createAsyncThunk("appUsers/getData", async (params) => {
//   const response = await axios.get("/api/users/list/data", params)
//   return {
//     params,
//     data: response.data.users,
//     totalPages: response.data.total
//   }
// })
// export const addUser = createAsyncThunk(
//   "appUsers/addUser",
//   async (user, { dispatch, getState }) => {
//     await axios.post("/apps/users/add-user", user)
//     await dispatch(getData(getState().users.params))
//     await dispatch(getAllData())
//     return user
//   }
// )
// export const deleteUser = createAsyncThunk(
//   "appUsers/deleteUser",
//   async (id, { dispatch, getState }) => {
//     await axios.delete("/apps/users/delete", { id })
//     await dispatch(getData(getState().users.params))
//     await dispatch(getAllData())
//     return id
//   }
// )

export const getPerson = createAsyncThunk("appPersons/getPerson", async (id) => {
  // Get the selected person (client or prospect)
  const person = await getAllFromController(`Persons/${id}`, "crm")
  // Get the logged in user
  const user = await getLoggedInUser()
  // if no company is assigned to the logged in user, return the person alone
  if (!user.internalCompanyId) {
    return person
  } else {
    // get the main interaction [0] between the person and the logged in user's company
    const interactions = await getPersonInteractions(id, user.internalCompanyId)
    return { ...person, interaction: interactions[0] }
  }
})

export const appPersonsSlice = createSlice({
  name: "appPersons",
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedPerson: null,
    formData: null
  },
  reducers: {
    resetFormAndPersonData: (state) => {
      state.selectedPerson = null
      state.formData = null
    },
    setFormData: (state, action) => {
      state.formData = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getPerson.fulfilled, (state, action) => {
      state.selectedPerson = action.payload
    })
    // .addCase(getAllData.fulfilled, (state, action) => {
    //   state.allData = action.payload
    // })
    // .addCase(getData.fulfilled, (state, action) => {
    //   state.data = action.payload.data
    //   state.params = action.payload.params
    //   state.total = action.payload.totalPages
    // })
  }
})

export const { resetFormAndPersonData, setFormData } = appPersonsSlice.actions
export default appPersonsSlice.reducer
